<template>
  <div class="ai-wrap">
    <div v-if="partList === undefined" class="xkh-empty-wrap">
      <img src="@/static/images/null/null-2.png" />
      <p>暂无内容</p>
    </div>
    <template v-else>
      <div class="part-list xkh-custom-scrollbar">
        <ul>
          <li v-for="(item, index) in partList" :key="item.index" @click="partChange(item)">
            <PartMsg :info="item" :is-cur="item.index === curPart.index" :index="index" />
          </li>
        </ul>
      </div>
      <div class="ai-right">
        <p class="part-name">
          {{ curPart.name }}
        </p>
        <div class="video-wrap" ref="videoWrap">
          <template v-if="!isLoading">
            <VideoScale v-if="isPolyv" :width="videoWidth" :height="videoHeight" ref="videoScale" />
            <AliVideoScale v-else :width="videoWidth" :height="videoHeight" ref="videoScale" />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import AliVideoScale from '@/components/VideoPlayer/videoScale.vue'
import VideoScale from '@/components/PolyvPlayer/VideoScale.vue'
import PartMsg from '@/components/PartMsg.vue'
import { defineComponent, ref } from 'vue-demi'
import service from '@/service/index'
export default defineComponent({
  name: 'AiCourse',
  components: { VideoScale, PartMsg, AliVideoScale },
  props: {
    classTypeId: Number,
    lessonId: Number
  },

  // mixins: [mixins],
  setup(props, { root, refs, emit }) {
    // 片段列表
    const partList = ref([])
    // 互动事件
    const scriptList = ref([])
    // 当前片段
    const curPart = ref({})
    const isVideoLoading = ref(true)
    const videoWidth = ref(0)
    const videoHeight = ref(0)

    // 数据加载中
    const isLoading = ref(true)
    const isPolyv = ref(true) // 是否是保利威视

    // watch(
    //   () => curPart.value,
    //   cur => {
    //     console.log('>>>>', cur)
    //   }
    // )

    /**
     * 初始化数据
     */
    const initData = async () => {
      const { classTypeId, lessonId } = props
      const { videoPartScriptJs, videoFragmentList, playerType, coursewareFragments, scriptJson, path } = await service.courseAndGroup.findCourseware(
        { classTypeId, lessonId }
      )
      isLoading.value = false
      if (playerType === 1) {
        isPolyv.value = true
      } else {
        isPolyv.value = false
      }
      partList.value = isPolyv.value ? coursewareFragments : videoPartScriptJs
      scriptList.value = isPolyv.value ? scriptJson : videoFragmentList

      // 未配置脚本信息
      if (!partList.value) {
        return
      }
      if (partList.value.length === 1) {
        partList.value[0].index = 0
      }
      curPart.value = partList.value[0] || {}
      root.$nextTick(() => {
        setVideoSize()
        if (isPolyv.value) {
          refs.videoScale
            .playerInit({
              scriptJson,
              videoUrl: path
            })
            .then(() => {
              // 初始化成功
              isVideoLoading.value = false
              refs.videoScale.voChangeTags([curPart.value])
            })
        } else {
          refs.videoScale.playerInit({
            fragmentList: videoFragmentList,
            videoList: videoPartScriptJs
          })
          // 初始化成功
          isVideoLoading.value = false
        }
      })
    }
    const setVideoSize = () => {
      if (!refs.videoWrap) {
        return
      }
      const { offsetWidth, offsetHeight } = refs.videoWrap
      videoWidth.value = offsetWidth
      videoHeight.value = offsetHeight
    }
    window.addEventListener('resize', setVideoSize)
    /**
     * 更换片段
     */
    const partChange = item => {
      curPart.value = item
      refs.videoScale.voChangeTags([item])
    }

    initData()
    return {
      isLoading,
      isPolyv,
      partList,
      scriptList,
      curPart,
      partChange,
      videoWidth,
      videoHeight
    }
  }
})
</script>
<style lang="less" scoped>
.ai-wrap {
  display: flex;
  height: 100%;
  ul {
    margin-bottom: 0;
  }
}
.part-list {
  padding: 20px;
  overflow-y: auto;
  width: 177px;
  border-right: 1px solid #ebedf0;
  ul {
    li {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.ai-right {
  width: calc(100vw - 654px);
  margin: 20px;
  .part-name {
    color: #505873;
    font-weight: 700;
    font-size: 16px;
    height: 34px;
  }
}
.video-wrap {
  height: calc(100% - 34px);
}
</style>
